export default __webpack_public_path__ + "static/media/fv_account.2ded5bee.svg";